import { History, ChevronDown, ChevronUp, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { parsePredictions } from './helpers';

/**
 * History Section Card
 */
export function HistoryCard({ 
  showHistory, 
  setShowHistory, 
  history, 
  loadingHistory, 
  onLoadHistory 
}) {
  const handleToggle = () => {
    const newShowHistory = !showHistory;
    setShowHistory(newShowHistory);
    if (newShowHistory && history.length === 0) {
      onLoadHistory();
    }
  };

  return (
    <Card>
      <CardHeader 
        className="pb-3 cursor-pointer hover:bg-slate-50 transition-colors"
        onClick={handleToggle}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <History className="w-5 h-5 text-purple-500" />
            Historikk
          </CardTitle>
          {showHistory ? (
            <ChevronUp className="w-5 h-5 text-slate-400" />
          ) : (
            <ChevronDown className="w-5 h-5 text-slate-400" />
          )}
        </div>
      </CardHeader>
      {showHistory && (
        <CardContent>
          {loadingHistory ? (
            <div className="flex justify-center py-4">
              <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
            </div>
          ) : history.length === 0 ? (
            <p className="text-center text-slate-400 py-4">Ingen tidligere identifikasjoner</p>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {history.map((item) => (
                <HistoryItem key={item.id} item={item} />
              ))}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}

function HistoryItem({ item }) {
  const topPrediction = parsePredictions(item.predictions)[0];
  
  return (
    <div className="p-3 bg-slate-50 rounded-lg text-sm">
      <div className="flex items-center justify-between">
        <span className="font-medium text-slate-700">{item.image_filename}</span>
        <span className="text-xs text-slate-400">
          {new Date(item.created_at).toLocaleDateString('nb-NO')}
        </span>
      </div>
      {topPrediction && (
        <p className="text-xs text-slate-500 mt-1">
          Beste match: {topPrediction.label || 'Ukjent'}
        </p>
      )}
    </div>
  );
}
